import { checkboxClasses as muiCheckboxClasses, getCheckboxUtilityClass } from '@mui/material';
import { CheckBoxSize, CheckboxTickRenderValues } from './types';

export const INDETERMINATE_PADDING = 3;

export const TICK_SIZES: Record<CheckBoxSize, CheckboxTickRenderValues> = {
  medium: {
    ax: 4,
    ay: 8,
    bx: 12,
    by: 5,
    rx: 20 / 3,
    ry: 10.558598553961973,
    containerSize: 16,
  },
  small: {
    ax: 3.5,
    ay: 7,
    bx: 10.5,
    by: 4.5,
    rx: (58 + 1 / 3) / 10,
    ry: 9.278652559956688,
    containerSize: 14,
  },
};

export const checkboxClasses = {
  ...muiCheckboxClasses,
  small: getCheckboxUtilityClass('small'),
  medium: getCheckboxUtilityClass('medium'),
  container: getCheckboxUtilityClass('container'),
  tick: getCheckboxUtilityClass('tick'),
};
